import clsx from 'clsx';
import React from 'react';

import imgRectangleLeft from 'images/pro/rectangle-left.svg';
import imgRectangleRight from 'images/pro/rectangle-right.svg';

import useCurrentUser from '../../hooks/useCurrentUser';
import { subscribe_promotion_path, upgrade_subscription_path } from '../../routes';
import {
  DEFAULT_ANNUAL_OFFER_CODE,
  DEFAULT_MONTHLY_OFFER_CODE,
  DEFAULT_PRO_OFFER_CODE,
  DEFAULT_YP_OFFER_CODE,
} from '../../src/constants';

const ProFooterCallout = () => {
  const { currentUser } = useCurrentUser();
  const isCurrentUserSubscriber = currentUser?.is_subscriber;
  const isCurrentUserProSubscriber = currentUser?.is_pro_subscriber;

  return (
    <div className="tw-bg-secondary-pink tw-px-16 xs:tw-px-48 tw-py-40 tw-text-center tw-relative">
      <div className="tw-relative tw-z-[1]">
        <p className="tw-font-sans tw-text-overline tw-text-primary-red tw-uppercase tw-m-0">
          {isCurrentUserSubscriber && !isCurrentUserProSubscriber
            ? 'Upgrade now'
            : !isCurrentUserSubscriber && 'Subscribe'}
        </p>
        <p className="tw-font-serif tw-text-headline-4 md:tw-text-headline-2 tw-text-primary-black tw-m-0 tw-mt-8 md:tw-mt-16">
          The Information Pro.
          <br />
          Don{'’'}t take a meeting without it.
        </p>
        {!isCurrentUserProSubscriber && (
          <a
            href={
              isCurrentUserSubscriber
                ? upgrade_subscription_path()
                : subscribe_promotion_path({
                    offer: `${DEFAULT_PRO_OFFER_CODE},${DEFAULT_ANNUAL_OFFER_CODE},${DEFAULT_MONTHLY_OFFER_CODE},${DEFAULT_YP_OFFER_CODE}`,
                  })
            }
            className={clsx(
              'tw-text-button tw-font-sans !tw-text-white tw-bg-primary-red uppercase',
              'xs:tw-w-[245px] tw-h-40 tw-flex tw-items-center tw-justify-center tw-rounded-r-2 tw-mx-auto tw-mt-16 md:tw-mt-32',
              'hover:tw-bg-pro-red focus:tw-bg-pro-red tw-transition-colors'
            )}
          >
            {isCurrentUserSubscriber ? 'Go Pro' : 'Get Started'}
          </a>
        )}
      </div>
      <div className="tw-absolute -tw-top-px tw-left-0 tw-w-[133px] xs:tw-w-[200px] sm:tw-w-[300px] md:tw-w-[416px]">
        <img
          className="tw-block tw-object-contain tw-object-top tw-w-full"
          src={imgRectangleLeft}
          alt=""
        />
      </div>
      <div className="tw-absolute -tw-bottom-px tw-right-0 tw-w-[133px] xs:tw-w-[200px] sm:tw-w-[300px] md:tw-w-[416px]">
        <img
          className="tw-block tw-object-contain tw-object-top tw-w-full"
          src={imgRectangleRight}
          alt=""
        />
      </div>
    </div>
  );
};

export default ProFooterCallout;
